import { useState } from 'react';
import ValidateData from './Views/ValidateData';
import UploadFileView from './Views/UploadFile';
import SeeDataView from './Views/SeeData';
import ErrorView from './Views/ErrorView';

import logo from '../assets/logo.jpg'
import '../styles/Home.css';
import 'handsontable/dist/handsontable.full.min.css';

const Home = () => {
  const [file, setFile] = useState(null);
  const [data, setData] = useState({});
  const [view, setView] = useState("ValidateData");
  // PossibleViews:
  //  -  "ValidateData" ->    First page to validate mail and reCaptcha
  //  -  "UploadFile"   ->    Page to upload file 
  //  -  "SeeData"      ->    Page to see the converted data and download the file
  //  -  "ErrorView"    ->    Other
  
  return (
    <div className="homePage">
      <div className="homePageContainer">
        <div className="fullWidth">
          <div className="header"></div>
          <div className="contentContainer">
            <div className="topContainer">
              <div className="spacer"></div>
              <div className="imgHomeContainer">
                <img src={logo} className="imgHome" alt="ProlamsaLogo"/>
              </div>

              <div className="textContainer">
                <div className="customTitle">Convertidor de archivos</div>
                <div className="customTitle">PDF a Excel mediante OCR</div>
              </div>
            
              {/* <div className="imgHomeContainer">
                <img src={logo} className="img" alt="ProlamsaLogo"/>
              </div> */}
            </div>

            <div className="customSubTitleContainer">
              <div className="customSubTitle">Convierta archivos de órdenes de compra de formato PDF a formato Excel</div>
            </div>

            { view === "ValidateData" ? (
              <ValidateData setView={setView}/>
            ) : view === "UploadFile" ? (
              <UploadFileView setView={setView} setData={setData} file={file} setFile={setFile}/>
            ) : view === "SeeData" ? (
              <SeeDataView setView={setView} data={data} file={file} setFile={setFile}/>
            ) : (
              <ErrorView setView={setView}/>
            )}
          </div>
        </div>
        <div className="footer"></div>
      </div>
    </div>
  )
};

export default Home